import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { faCircleExclamation } from "@fortawesome/pro-light-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import useCsvUpload from "../../hooks/useCsvUpload";
import Button from "../common/Button";
function ValidationErrorView() {
  var _state$result;
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 2),
    state = _useCsvUpload2[0],
    dispatch = _useCsvUpload2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 justify-center items-center gap-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleExclamation,
    className: "text-red-400"
  }), /*#__PURE__*/React.createElement("p", null, (_state$result = state.result) === null || _state$result === void 0 || (_state$result = _state$result.data) === null || _state$result === void 0 ? void 0 : _state$result.message)), /*#__PURE__*/React.createElement(Button, {
    isSecondary: true,
    onClick: function onClick() {
      dispatch({
        type: "reset"
      });
      dispatch({
        type: "upload"
      });
    }
  }, "Upload another file"));
}
export default ValidationErrorView;